const CloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='Close'
      className={className}
    >
      <rect
        x='0.9'
        y='0.9'
        width='48.2'
        height='48.2'
        rx='7.1'
        strokeWidth='1.8'
      ></rect>
      <path
        d='M18.3711 31.9062L31.6293 18.648'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
      ></path>
      <path
        d='M18.3711 18.6484L31.6293 31.9067'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
      ></path>
    </svg>
  );
};

export default CloseIcon;
